import React from 'react';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function MaybeWrapper({
  wrapper,
  children,
  condition
}) {
  if (!condition) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: wrapper(children)
  });
}